// Wind model: time-of-day slots, wind vectors, and effective ground speed.
// Pure functions, no DOM.

import {
  DAY_LENGTH, TIME_SLOTS, COMPASS, SPEED, WIND_SCALE, MIN_SPEED_FACTOR, MAX_SPEED_FACTOR,
} from '../config/constants.js';

/** Time-of-day slot for game time `t`: each day is split into four equal slots. */
export function timeOfDay(t, dayLength = DAY_LENGTH) {
  const m = ((t % dayLength) + dayLength) % dayLength;
  return TIME_SLOTS[Math.min(3, Math.floor(m / (dayLength / 4)))];
}

/** Vector the wind blows TOWARD, in scope-fraction/sec. Screen y grows downward (south). */
export function windVector({ speed, dir }) {
  const rad = ((dir + 180) % 360) * Math.PI / 180;
  const mag = speed * WIND_SCALE;
  return { x: Math.sin(rad) * mag, y: -Math.cos(rad) * mag };
}

/**
 * Effective ground speed for a straight leg from `from` to `to` in the given
 * wind: tailwind speeds the leg up, headwind slows it, clamped so a drone
 * never stalls or doubles its speed.
 */
export function effectiveSpeed(from, to, slotWind) {
  const dx = to.x - from.x;
  const dy = to.y - from.y;
  const d = Math.hypot(dx, dy) || 1;
  const wv = windVector(slotWind);
  const along = (wv.x * dx + wv.y * dy) / d;
  return Math.max(SPEED * MIN_SPEED_FACTOR, Math.min(SPEED * MAX_SPEED_FACTOR, SPEED + along));
}

/** Prefixes of the types a given wind speed grounds (speed strictly over their limit). */
export function typesGroundedBy(speed, types) {
  return types.filter((t) => speed > t.maxWind).map((t) => t.prefix);
}

export function compassLabel(deg) {
  const match = COMPASS.find((c) => c.deg === deg);
  return match ? match.label : `${deg}°`;
}
